import React from "react";

const AppML_Models = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Models</h1>
      <p>This is the AppML Models page content.</p>
    </div>
  );
};

export default AppML_Models;
